import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import Image from "../image/Image"
import style from './screens-banner.module.css'

function ScreensBanner() {
    const data = useStaticQuery(graphql`
        query {
            screen1: file(relativePath: { eq: "screenshots/inventoryframed.png" }) {
                childImageSharp {
                    fluid(maxWidth: 300) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            screen2: file(relativePath: { eq: "screenshots/itemframed-1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 300) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            screen3: file(relativePath: { eq: "screenshots/containerframed-1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 300) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            screen4: file(relativePath: { eq: "screenshots/itemsframed-1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 300) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            screen5: file(relativePath: { eq: "screenshots/commonsframed-1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 300) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    return (
        <div className="boxwrapper" style={{
            marginTop: "20px",
            width: "100%"
        }}>
            <div className={style.screensbanner}>
                <div className={style.screen}>
                    <Image fluid={data.screen1.childImageSharp.fluid}/>
                </div>
                <div className={style.screen}>
                    <Image fluid={data.screen2.childImageSharp.fluid} />
                </div>
                <div className={style.screen}>
                    <Image fluid={data.screen3.childImageSharp.fluid} />
                </div>
                <div className={style.screen}>
                    <Image fluid={data.screen4.childImageSharp.fluid} />
                </div>
                <div className={style.screen}>
                    <Image fluid={data.screen5.childImageSharp.fluid} />
                </div>
            </div>
        </div>
        
    );
}

export default ScreensBanner;